export default __webpack_public_path__ + "static/media/shayan-white.8b11e891.svg";